<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form ref="searchForm">
                    <c-form-item type="input" label="抽奖会员" name="user_info" placeholder="匹配昵称、手机号"></c-form-item>
                    <c-form-item type="input" label="奖项名称" name="lottery_award_name" ></c-form-item>
                    <c-form-item type="datetime" label="抽奖时间" start-name="start_date" end-name="end_date"></c-form-item>
                    <c-form-item type="checkbox" label="中奖状态" name="win_state" :options="winState"></c-form-item>
                    <c-form-item type="checkbox" label="奖品类型" name="award_type" :options="awardTypeOption"></c-form-item>
                    <c-form-item type="checkbox" label="发放状态" name="state" :options="state"></c-form-item>
                </c-form>
            </m-search>

            <c-table ref="table">
                <c-table-column
                        label="抽奖时间"
                        name="create_date"
                        width="140"
                ></c-table-column>

                <c-table-column
                        label="抽奖会员"
                        name="nick_name"
                        width="160"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            <span v-if="data.user_manage_mobilephone">{{data.user_manage_mobilephone}}</span>
                            <span v-if="data.nick_name">({{data.nick_name}})</span>
                        </div>
                    </template>
                </c-table-column>

                <c-table-column
                        label="中奖状态"
                        name="win_state"
                        width="90"
                >
                    <template v-slot="{data}">
                        <span v-if="data.win_state==0" style="color:red">未中奖</span>
                        <span v-if="data.win_state==1" style="color:darkgreen">中奖</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="奖项名称"
                        name="lottery_award_name"
                        width="150"
                >
                    <template v-slot="{data}">
                        <span v-if="data.win_state==1">{{data.lottery_award_name}}</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="奖品类型"
                        name="award_type"
                        width="90"
                >
                    <template v-slot="{data}">
                        <span v-if="data.win_state==1 && data.award_type==1">商品</span>
                        <span v-else-if="data.win_state==1 &&data.award_type==2" style="color:darkgreen">积分</span>
                        <span v-else-if="data.win_state==1 &&data.award_type==3" style="color:blue">优惠券</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="奖品发放状态"
                        name="state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.win_state==1 &&data.state==1" style="color:darkgreen">{{stateName[data.state]}}</span>
                        <span v-else-if="data.win_state==1 &&data.state==0" style="color:red">{{stateName[data.state]}}</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                >
                    <template v-slot="{data}">
                        <c-table-button v-if="data.win_state==1" @click="navigateTo(`/lottery_win_record_detail/${data.id}`)">中奖详情</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>
    </page>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: 'm_lottery_win_record',

        data() {
            return {
                stateName: {
                    0: '待发放',
                    1: '已发放'
                },
                awardTypeOption: [
                    {name: '商品',value: 1},
                    {name: '积分',value:2},
                    {name: '优惠券',value:3}
                ],
                winState: [{
                    name: '未中奖',
                    value: 0
                }, {
                    name: '中奖',
                    value: 1
                }],
                state: [{
                    name: '待发放',
                    value: 0
                }, {
                    name: '已发放',
                    value: 1
                }]
            }
        },

        computed: {
            ...mapState(['systemConfig', 'userInfo']),
            defaultSearch() {
                let param = {
                    win_state: [1],
                }
                return param;
            }
        },

        mounted() {
            //搜索条件默认设置为：待审核
            this.$refs.searchForm.set(this.defaultSearch);

            this.$nextTick(() => {
                this.$refs.search.search();
            })
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/lottery_win_record/list',
                    data
                });
            }
        }
    }
</script>